import { servicePendingTasks } from 'services';
import useMutationHookWrapper, {
    TAsyncStatesHandlers,
} from 'hooks/use-mutation-hook-wrapper';
import { pendingTasks as typesPendingTasks, network } from 'types';

const useRejectPendingTask = (
    arg0?: TAsyncStatesHandlers<network.TQueryDefWrapper<null>, string>,
) => {
    return useMutationHookWrapper<
        network.TQueryDefWrapper<null>,
        string,
        typesPendingTasks.TPendingTasks
    >({
        mutationFn: servicePendingTasks.reject,
        mutationConfig: {},
        asyncStateHandlers: arg0,
    });
};

export default useRejectPendingTask;
